import { Config } from "../../../../../../../api/config";
export var InterWarehouseTransferRequisitionKeys = {
    Upload: "Upload",
    Paging: "Paging",
    Update: "Update",
    Create: "Create",
    Get: 'interWarehouseTransferRequisitionGet',
    GetPartList: 'interWarehouseStockTransferRequisitionGetPartList',
    AttachmentList: 'getInterwarehouseAttachmentList',
    OtherDetails: 'getOtherDetails',
    TransportList: 'getTransportList',
    UOMDetailsByProductId: 'getUOMDetailsByProductId',
    LocationDetails: 'getLocationDetails',
    ProductPrices: 'getProductPricesAPI',
    AttachmentSystemName: 'InventoryAttachment'
};
export var viewTypeOptions = ["My requisitions", "All requisitions"];
export var visibleColumns = {
    DocumentCode: 'Document Number',
    DocumentDate: "Requisition Date",
    CreatedBy: "Created by",
    CreatedOn: "Created date",
    SourceWarehouseName: "Source warehouse",
    DestinationWarehouse: "Destination warehouse",
    ExpectedTransferDate: "Expected Transfer Date",
    StatusName: "Status",
    TotalAmount: "Total Amount"
};
export var interWarehouseTransferRequisitionPagingAPI = "".concat(Config.baseURL, "StockTransferRequisition/Paging");
export var interWarehouseTransferRequisitionCreateAPI = "".concat(Config.baseURL, "StockTransferRequisition/CreateWToWRequisition");
export var interWarehouseTransferRequisitionGetPartsAPI = "".concat(Config.baseURL, "StockTransferRequisitionDetail/GetByStockTransferRequisitionId");
export var statusProgressListAPI = "".concat(Config.baseURL, "DocumentStatus/DocumentStatusList");
export var transporterListAPI = "".concat(Config.baseURL, "Transporter/List");
export var interWarehouseRequisitionAttachmentCreateAPI = "".concat(Config.baseURL, "InventoryAttachment/Create");
export var getUOMDetailsByProductIdAPI = "".concat(Config.baseURL, "ProductInventoryDefaultConfiguration/CheckDefaultTrackingType");
export var interWarehouseRequisitionDeleteAttachmentAPI = "".concat(Config.baseURL, "InventoryAttachment/DeleteInventoryAttachment");
export var getAvailableQuantityByWarehouseAPI = "".concat(Config.baseURL, "Inventory/GetAvailableQtyByWarehouse");
export var getProductPricesAPI = "".concat(Config.baseURL, "ProductSalePrice/GetPriceDetail");
export var getOtherDetailsAPI = function (id) { return "".concat(Config.baseURL, "StockTransferRequisition/").concat(id, "/GetOtherDetails"); };
export var interWarehouseTransferRequisitionGetAPI = function (id) { return "".concat(Config.baseURL, "StockTransferRequisition/").concat(id, "/StockTransferRequisitionWithDetails"); };
export var InterWarehouseReqPartDetailsMandatoryFeilds = {
    'ProductId': 'Product',
    'RequestedQuantity': 'RequestedQuantity',
    'SourceLocations': 'SourceLocations',
    'DestinationLocations': 'DestinationLocations'
};
export var StatusList = {
    'Product': 'Product',
    'RequestedQuantity': 'RequestedQuantity',
    'SourceLocations': 'SourceLocations',
    'DestinationLocations': 'DestinationLocations'
};
export var EStatusNames = /*#__PURE__*/ function (EStatusNames) {
    EStatusNames["Completed"] = "Completed";
    EStatusNames["Draft"] = "Draft";
    return EStatusNames;
}({});
export var EStocktransferTypes = /*#__PURE__*/ function (EStocktransferTypes) {
    EStocktransferTypes["WToWRequisition"] = "WToWRequisition";
    EStocktransferTypes["WToWOutward"] = "WToWOutward";
    EStocktransferTypes["WToWInward"] = "WToWInward";
    EStocktransferTypes["BToBOutward"] = "BToBOutward";
    return EStocktransferTypes;
}({});
